import React from "react";
import ReactDOM from "react-dom";

export function LoadingAnimation(props) {
    const width = props.width ? props.width : 76;
    const height = props.height ? props.height : 20;
    const className = props.className ? props.className : '';
    const color = props.color ? props.color : 'blue123';

    return (
        <div className={"text-center " + className} style={props.style ? props.style : {}}>
            <img src={(props.searchURLBase ? props.searchURLBase : '') + "/assets/img/front/icons/loading-dots-" + color + ".svg"} width={width} height={height} alt="loading" />
        </div>
    );
}
